<template>
<div>
    <loader v-if="loading"/>
    <template v-if="!loading">
        <chart :chartData="chartData"/>
    </template>
</div>
</template>
<script>
import Chart from './Chart.vue';
import Loader from '@/components/Loader.vue';
import axios from 'axios';
window.Handbook = window.Handbook || {}
const apiUri = window.Handbook.ApiUri || "https://localhandbookapi.aph.gov.au/";
axios.defaults.baseURL = apiUri;

export default {
    props: ['selectedMpOrSenator'],
    created() {
        this.initialiseData();
    },
    data() {
        return {
            loading: true,
            data: []
        }
    },
    components: {
        Chart,
        Loader
    },
    methods: {
        initialiseData() {
            this.loading = true;
            const parliamentarianType = this.selectedMpOrSenator.length == 0 || this.selectedMpOrSenator.length == 2 ?
                '' : this.selectedMpOrSenator[0];
            const url = `StatisticalInformation/ElectionProportionalityOverTime?mpOrSenator=${parliamentarianType}`;
            axios.get(`api/${url}`)
                .then(response => {
                    this.data = response.data;
                    // this.data = response.data;
                    this.loading = false;
                });
        }
    },
    computed: {
        chartData() {
            // unique
            const parties = 
            this._.uniqBy(
                this.data
                    .flatMap(d => d.Parties)
                    .map(p => ({ Party: p.Party, PartyColour: p.PartyColour })), 'Party');

            const series = parties.map(p => ({
                name: p.Party,
                color: p.PartyColour,
                data: this.data.map(d => d.Parties.find(pa => pa.Party === p.Party) ?
                { 
                    x: d.Year, 
                    y: d.Parties.find(pa => pa.Party === p.Party).SeatsPercentage -
                    d.Parties.find(pa => pa.Party === p.Party).PercentageVotes,
                    seats: d.Parties.find(pa => pa.Party === p.Party).SeatsPercentage,
                    votes: d.Parties.find(pa => pa.Party === p.Party).PercentageVotes
                }
                : [d.Year, 0])
            }));
            
            return {
                chart: {
                    height: 500
                },
                title: {
                    text: 'Difference between seats won (%) and votes received (%) over time'
                },

                yAxis: {
                    title: {
                        text: 'Difference between seats won (%) and votes received (%)'
                    }
                },

                tooltip: {
                    valueDecimals: 2,
                    valueSuffix: '%',
                    formatter: function() {
                        return `${this.series.name} | Seats (${this.point.seats.toFixed(2)}%) - Votes (${this.point.votes.toFixed(2)}%) = ${this.point.y.toFixed(2)}`;
                    }
                },

                legend: {
                    layout: 'vertical',
                    align: 'right',
                    verticalAlign: 'middle'
                },

                plotOptions: {
                    series: {
                        label: {
                            connectorAllowed: false
                        },
                    }
                },
                series,
                responsive: {
                    rules: [{
                        condition: {
                            maxWidth: 500
                        },
                        chartOptions: {
                            legend: {
                                layout: 'horizontal',
                                align: 'center',
                                verticalAlign: 'bottom'
                            }
                        }
                    }]
                }
            }
        }
    }
}
</script>